"use client";

import { useEffect, useState } from "react";

import { useUserSettings } from "@/data/user-settings.atom";

export const useLocalStorageReady = () => {
  const { userSettings } = useUserSettings();
  const [isReady, setIsReady] = useState(false);

  useEffect(() => {
    // Check if we're on the client side
    if (typeof window === "undefined") {
      return;
    }

    // Check if userSettings has been loaded (even if it's null, that means it was loaded)
    // The key is that userSettings is no longer undefined
    if (userSettings !== undefined) {
      setIsReady(true);
    }
  }, [userSettings]);

  return isReady;
};

// Hook to check if table data is ready (for components that need table data)
export const useTableReady = () => {
  const [isReady, setIsReady] = useState(false);

  useEffect(() => {
    // Small delay to ensure any table filtering is complete
    const timer = setTimeout(() => {
      setIsReady(true);
    }, 200); // Slightly longer delay to ensure table is ready

    return () => clearTimeout(timer);
  }, []);

  return isReady;
};
